import { add } from '../../product-features/services/ProductFeaturesService';
import { generateProductFeatureName } from './nameGenerators';

const categories = ['Core Features', 'Premium Features', 'Enterprise Features', 'Integration Features', 'Security Features', 'Analytics Features', 'Management Features', 'Support Features'];

const generateProductFeatureData = () => {
  const name = generateProductFeatureName();
  const category = categories[Math.floor(Math.random() * categories.length)];
  return {
    name,
    description: `${name} - Enhanced functionality for improved user experience and operational efficiency.`,
    category
  };
};

export const generateProductFeaturesTestData = async (count: number) => {
  const promises = [];
  
  for (let i = 1; i <= count; i++) {
    const featureData = generateProductFeatureData();
    promises.push(add(featureData));
  }
  
  try {
    const results = await Promise.all(promises);
    console.log(`Generated ${count} test product features`);
    return results.filter(Boolean);
  } catch (error) {
    console.error('Error generating product features test data:', error);
    return [];
  }
};